export class Toast {
	static async ShowSuccess(title, message, options) {
		return this.#Open("SUCCESS", {
			Title: title,
			Message: message,
			Icon: "fas fa-check", ...options
		});
	}

	static async ShowWarning(title, message, options) {
		return this.#Open("WARNING", {
			Title: title,
			Message: message,
			Icon: "fas fa-exclamation-triangle", ...options
		});
	}

	static async ShowInfo(title, message, options) {
		return this.#Open("INFO", {
			Title: title,
			Message: message,
			Icon: "fas fa-info-circle", ...options
		});
	}

	static async ShowError(title, message, options) {
		return this.#Open("ERROR", {
			Title: title,
			Message: message,
			Icon: "fas fa-times-octagon", ...options
		});
	}

	static #RenderToast(type, options) {
		let message = options.Message ?? "";

		if (options.Message) {
			message = `<span class="ms-sm">${message}</span>`;
		}

		const toast = document.createElementWithContents("div", `
        <div class="chip-toast toast-${type.toLowerCase()}" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="row gx-3">
						<div class="col-auto"><i class="${options.Icon}"></i></div>
						<div class="col"><span class="${message?.trim() ? "fw-bold" : ""}">${options.Title}</span>${message}</div>
						<div class="col-auto"><chip-button variation="body" button-style="icon" icon="far fa-times"></chip-button></div>
          </div>
        </div>`).firstElementChild;

		toast.querySelector("chip-button").onclick = () => this.CloseToast(toast);

		return toast;
	}

	static CloseToast(toast) {
		toast.remove();
	}

	static #Open(type, options) {
		const toast = this.#RenderToast(type, options);
		this.#GetOrCreateContainer()?.appendChild(toast);

		let timeout = setTimeout(() => Toast.CloseToast(toast), 5000);

		toast.onmouseenter = () => clearTimeout(timeout);
		toast.onmouseleave = () => timeout = setTimeout(() => Toast.CloseToast(toast), 5000);

		setTimeout(() => {
			toast.classList.add("show");
		}, 1);
	}

	static #GetOrCreateContainer() {
		const toastContainer = document.querySelector(".toast__wrapper") ?? document.createElementWithContents("div", "", { className: "toast__wrapper" });

		if (toastContainer) {
			document.body.prepend(toastContainer);
		}

		return toastContainer;
	}
}